/**
* @Author: zachalam
* @Date:   2017-01-19T17:18:40-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T17:19:08-08:00
*/


import React, { Component } from 'react';
import Mail from '../components/pages/Mail/Mail';
import { connect } from 'react-redux';
import { refreshMail } from '../actions/mailActions';
import { refreshAccount } from '../actions/profileActions';

class MailContainer extends Component {
  state = {
    lastPage: this.props.route.page
  }

  componentWillMount() {
    const {
      refresh,
      route
    } = this.props;

    refresh(route.page);
  }

  componentWillReceiveProps(nextProps) {
    let next = nextProps.route.page;
    if(next != this.state.lastPage) {
      this.props.refresh(next);
      this.setState({lastPage: next});
    }
  }

  render() {
    return (
      <Mail {...this.props} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    myProfile: state.profile,
    mail: state.mail,
    moreExists: Boolean(state.meta.mail_current_page < state.meta.mail_total_pages)
  }
};

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    refresh(route) {
      dispatch(refreshMail(route, true));
    },
    refreshAccount() {
      dispatch(refreshAccount());
    },
    loadMore(route) {
      // show more mail
      dispatch(refreshMail(route, false));
    }
  };
}

export default connect(mapStateToProps,mapDispatchToProps)(MailContainer);



// WEBPACK FOOTER //
// ./src/containers/MailContainer.jsx